/* eslint-disable no-alert */
import React, { useState, useRef, forwardRef, useImperativeHandle } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Snackbar,
  Typography,
} from '@material-ui/core';
import { Attachment, Close } from '@material-ui/icons';
import { TipoDocumentoPartner } from '@omega-energia/utilities';
import request from '../../../../../services/network/request';

const FileUploader = forwardRef((props, ref) => {
  const { partnerPublicId, invoiceId, token, refetch, documentoRepresentanteId } = props;
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [fileToUpload, setFileToUpload] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: '' });
  const [previewUrl, setPreviewUrl] = useState('');
  const inputRef = useRef();

  useImperativeHandle(ref, () => ({
    openFileDialog: () => {
      inputRef.current?.click();
    },
  }));

  const handleFileSelect = event => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      setFileToUpload({
        documento: file,
        filename: file?.name,
      });
      const fileReader = new FileReader();
      fileReader.onload = () => {
        setPreviewUrl(fileReader.result);
        setOpen(true);
      };
      fileReader.readAsDataURL(file);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  async function updateNotaFiscal(documentPartnerId) {
    await request.put(`representante/invoices/${invoiceId}/document`, { documentPartnerId }, { token });
  }

  const handleUpload = async () => {
    if (!fileToUpload.documento) {
      return;
    }
    setIsLoading(true);
    const formData = new FormData();
    formData.append('documento', fileToUpload.documento);
    formData.append('partnerPublicId', partnerPublicId);
    formData.append('tipoDocumento', TipoDocumentoPartner.NOTA_FISCAL);
    if (documentoRepresentanteId) {
      formData.append('documentoRepresentanteId', documentoRepresentanteId);
    }

    // uploads no BS precisam setar o contentType como false pro middleware não definir como JSON
    const response = await request.post('representante/documentos/upload', formData, {
      token,
      contentType: false,
    });

    if (response?.id) {
      try {
        await updateNotaFiscal(response.id);
        setSnackbar({ open: true, message: 'Nota fiscal substituída no sistema' });
        setTimeout(() => {
          handleClose();
          refetch();
        }, 2000);
      } catch (error) {
        setIsLoading(false);
        setSnackbar({ open: true, message: 'Erro ao salvar a nota fiscal' });
        // eslint-disable-next-line no-console
        console.error(error);
      }
    }
  };

  return (
    <>
      <input type="file" hidden accept="image/*,.pdf,application/pdf" onChange={handleFileSelect} ref={inputRef} />

      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Pré-visualização do documento</Typography>
            <IconButton onClick={handleClose} size="small">
              <Close />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            my={2}
            sx={{
              maxHeight: '500px',
              overflow: 'auto',
              border: '1px solid #eee',
              borderRadius: '4px',
              p: 2,
            }}
          >
            {previewUrl &&
              (fileToUpload?.documento?.type === 'application/pdf' ? (
                <iframe
                  src={previewUrl}
                  title="Pré-visualização do PDF"
                  width="100%"
                  height="450px"
                  style={{ border: 'none' }}
                />
              ) : (
                <img
                  src={previewUrl}
                  alt="Pré-visualização"
                  style={{
                    maxWidth: '100%',
                    maxHeight: '450px',
                    objectFit: 'contain',
                  }}
                />
              ))}
          </Box>
          <Typography variant="body2" color="textSecondary">
            Arquivo selecionado: {fileToUpload?.filename}
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} color="inherit">
            Cancelar
          </Button>
          <Button
            onClick={handleUpload}
            color="primary"
            disabled={isLoading}
            variant="contained"
            startIcon={<Attachment />}
          >
            Enviar
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={2000}
        message={snackbar.message}
        onClose={() => setSnackbar({ open: false, message: '' })}
      />
    </>
  );
});

export default FileUploader;
